<div class="data-import-page">
  <div class="mb-4">
    <h4 class="mb-2">{{ 'Settings::DataImport:Title' | abpLocalization }}</h4>
    <p class="text-muted mb-0">{{ 'Settings::DataImport:PageDescription' | abpLocalization }}</p>
  </div>

  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3 text-muted">{{ 'Settings::DataImport:LoadingData' | abpLocalization }}</p>
    </div>
  </div>

  <div *ngIf="!isLoading" class="content-fade-in">
    <div class="row g-3">
      <div class="col-12">
        <app-import-card
          [source]="ImportSource.CA"
          [title]="'Settings::DataImport:ConversationalAnalytics' | abpLocalization"
          iconClass="fas fa-chart-mixed"
          [state]="caState"
          [systemStartDate]="caSystemStartDate"
          [isStarting]="startingImportSource === ImportSource.CA"
          (startImport)="onStartImport(ImportSource.CA, $event)"
          (stopImport)="onStopImport(ImportSource.CA)"
          (progressClick)="onProgressClick(ImportSource.CA)"
          (errorClick)="onErrorClick(ImportSource.CA)"
        ></app-import-card>
      </div>

      <div class="col-12">
        <app-import-card
          [source]="ImportSource.VA"
          [title]="'Settings::DataImport:VirtualAgent' | abpLocalization"
          iconClass="fas fa-message-bot"
          [isStarting]="startingImportSource === ImportSource.VA"
          [state]="vaState"
          [systemStartDate]="vaSystemStartDate"
          (startImport)="onStartImport(ImportSource.VA, $event)"
          (stopImport)="onStopImport(ImportSource.VA)"
          (progressClick)="onProgressClick(ImportSource.VA)"
          (errorClick)="onErrorClick(ImportSource.VA)"
        ></app-import-card>
      </div>
    </div>
  </div>
</div>
